
import styled from "styled-components";

import ArrowDown from '../../assets/icons/icon-arrow-down-circle-gray.png';
import { theme } from "../../styles/theme";

export const Container = styled.div`
    width: 100%;
    padding: 1.5rem;
    height: 20.625rem;

    display: flex;
    flex-direction: column;

    border-radius: 1rem;
    background-color: #F8F8F9;

    transition: all 0.3s ease;

      @media (max-width: 1320px) {
            max-width: 64.875rem;
      }

      @media (max-width: 760px) {
            padding: 1rem;
            height: ${({ isFrequentProblemsSelected }) => (isFrequentProblemsSelected ? 'auto' : '22.5rem')};
      }
`;

export const ChartContainer = styled.div`
    width: 100%;
    height: 100%;
    
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;


export const Header = styled.div`
      width: 100%;
      
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;

      @media (max-width: 479px) {
            gap: 1rem;
            flex-direction: column;
      }
`;

export const FarmSelect = styled.select`
    appearance: none; 
    -moz-appearance: none;
    -webkit-appearance: none; 

    width: auto;
    height: auto;
    padding: 0.5rem 2.813rem 0.5rem 1rem;

    cursor: pointer;
    color: ${theme.colors.gray.Cinza_2};
    font-weight: 800;
    font-size: 0.625rem;
    font-family: "Lato";
    line-height: 1.375rem;
    letter-spacing: 0.1rem;
    text-transform: uppercase;

    border-radius: 62rem;
    background-size: 1.25rem;
    border: 0.063rem solid black;
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: 1rem;
    background-image: url(${ArrowDown});
    background-position: right 1.188rem center;

    @media (max-width: 360px) {
        font-size: 0.55rem;
        text-align: center;
    }
`;


export const FarmSelector = styled.button`
      all: unset;
      top: 0.15rem;
      left: 0.5rem;
      position: relative;
      
      
      cursor: pointer;
      transition: 0.4s;

      > img{
            width: 1.25;
      }

      @media (max-width: 400px) {
            left: 0.1rem;
      }
`;

export const Report = styled.a`
      display: flex;
      
      gap: 0.3rem;
      align-items: center;
      
      letter-spacing: 0.1rem;

      > p{
            cursor: pointer;
      }

      @media (max-width: 400px) {

            > img {
                  width: 0.75rem;
            }
      }
`;

export const Body = styled.div`
    width: 100%;
    height: 100%;
    
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

      > h1{
            text-align:center; 
            font-size: 1.25rem;
      }

      >img{
            width: 100%;
            height: auto;

            margin-top: 2rem;
      }
`;

export const ButtonHeader = styled.button`
      all: unset;
      max-width: 11.625rem;
      padding: 1rem 2.5rem;
      
      display: flex;
      margin-top: 1.5rem;
      align-items: center;
     
      cursor: pointer;
      border-radius: 62rem;
      background-color: #2FBB69;

      img{
            width: 1.3rem;
            
            margin-right: 1rem;

            @media (max-width: 612px) {
                  width: 1rem;
                  
                  margin-right: 0.4rem;
            }
      }

      @media (max-width: 612px) {
            width: 9.125rem;
            
            font-size: 0.5rem;
      }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }

      position: relative;

      width: 4.688rem;
      height: 4.688rem;

      margin: auto;

      border-radius: 50%;
      background-color: transparent;
      border-top: 1px solid ${theme.colors.green.Bandeira};
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
      border-bottom:  1px solid ${theme.colors.green.Bandeira};
      
      animation: rotating 0.7s linear infinite;
      -o-animation: rotating 0.7s linear infinite;
      -ms-animation: rotating 0.7s linear infinite;
      -moz-animation: rotating 0.7s linear infinite;
      -webkit-animation: rotating 0.7s linear infinite;
`;

export const ContainerGraphics = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    margin-top: -1rem;
    justify-content: space-between;

    >div:nth-of-type(1) {

      
      @media (max-width: 479px) {
            align-items: center;
      }
            
      >div:nth-of-type(1) {
            width: 8rem !important;
            height: 11rem !important;

            >div{
                  >canvas{
                        left: auto !important;
                        right: 0.5rem !important;
                  }  
            }
      }
    }

    >div:nth-of-type(2) {
      align-items: center;

      >div:nth-of-type(1) {
            width: 8rem !important;
            height: 11rem !important;
      }

      @media (max-width: 479px) {
            align-items: center;
      }
    }

    >div:nth-of-type(3) {
      align-items: flex-end;
          

      >div:nth-of-type(1) {
            width: 8rem !important;
            height: 11rem !important;


          >div{
                  >canvas{
                        left: 0.5rem !important;
                  }  
            }

      }

      >div:nth-of-type(2) {
            align-items: flex-end;

            div{
                  flex-direction: row-reverse;

                  >p{
                        text-align: end;
                  }
            }
       }

       @media (max-width: 479px) {
            align-items: center;
      }
    }

      @media (max-width: 479px) {          
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
      }
`;

export const ChartArea = styled.div`
    width: 100%;
    height: auto;
    min-height: 100px;

    .text-alert p{
        margin-top: 19px;
        margin-bottom: 0px;
        font-size: 11.5px;
        text-align: justify;
    }
`;

export const IconeBotao = styled.div`
    display: flex;
    justify-content: space-between

    .pdf{
      #msgBaixarPdf{
        display: none;
      } 
  
      &:hover{
        #msgBaixarPdf{
            transform: scale(1.1);
            display: flex;
            justify-content: center;
            position:absolute;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            align-items: center;
            color:#FFF;
            background-color: ${theme.colors.gray.Cinza_1};
            width: 80px !important;
            height: 18px;
            opacity: 0.9;
            border-radius: 5px;
            margin-top: -17px;
            margin-left: -33px;
  
            &:after{
                display:flex;
                position: absolute;
                background-color:  ${theme.colors.gray.Cinza_1};
                width: 6px;
                height: 6px;
                top: 14px;
                margin-left: 0px;
                content: '';
                transform: rotate(45deg);
            }
        }
      }
    }

    .xlsx{
      #msgBaixar{
        display: none;
      } 
  
      &:hover{
        #msgBaixar{
            transform: scale(1.1);
            display: flex;
            justify-content: center;
            position:absolute;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            text-align: center;
            align-items: center;
            color:#FFF;
            background-color: ${theme.colors.gray.Cinza_1};
            width: 80px !important;
            height: 18px;
            opacity: 0.9;
            border-radius: 5px;
            margin-top: -42px;
            margin-left: -30px;
  
            &:after{
                display:flex;
                position: absolute;
                background-color:  ${theme.colors.gray.Cinza_1};
                width: 6px;
                height: 6px;
                top: 14px;
                content: '';
                transform: rotate(45deg);
            }
        }
      }
    }
`;
